var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      ref: "mod",
      attrs: { minimized: "", "position-classes": "items-start justify-end" },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "div",
        { staticClass: "column items-start" },
        [
          _c(
            "q-btn",
            {
              staticClass: "full-width",
              attrs: {
                "no-caps": "",
                color: "primary",
                size: "lg",
                align: "left",
                flat: "",
                icon: "photo_camera"
              }
            },
            [
              _vm._v("\n      Фото\n      "),
              _c("input", {
                staticClass: "q-uploader-input absolute-full cursor-pointer",
                attrs: { type: "file", multiple: "", accept: "image/*" },
                on: { change: _vm.done, click: _vm.hide }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              staticClass: "full-width",
              attrs: {
                "no-caps": "",
                color: "primary",
                size: "lg",
                align: "left",
                flat: "",
                icon: "mic"
              }
            },
            [
              _vm._v("\n      Аудио\n      "),
              _c("input", {
                staticClass: "q-uploader-input absolute-full cursor-pointer",
                attrs: { type: "file", multiple: "", accept: "audio/*" },
                on: { change: _vm.done, click: _vm.hide }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              staticClass: "full-width",
              attrs: {
                "no-caps": "",
                color: "primary",
                size: "lg",
                align: "left",
                flat: "",
                icon: "videocam"
              }
            },
            [
              _vm._v("\n      Видео\n      "),
              _c("input", {
                staticClass: "q-uploader-input absolute-full cursor-pointer",
                attrs: { type: "file", multiple: "", accept: "video/*" },
                on: { change: _vm.done, click: _vm.hide }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              staticClass: "full-width",
              attrs: {
                "no-caps": "",
                color: "primary",
                size: "lg",
                align: "left",
                flat: "",
                icon: "insert_drive_file"
              }
            },
            [
              _vm._v("\n      Документ\n      "),
              _c("input", {
                staticClass: "q-uploader-input absolute-full cursor-pointer",
                attrs: { multiple: "", type: "file", accept: "*" },
                on: { change: _vm.done, click: _vm.hide }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              staticClass: "full-width",
              attrs: {
                "no-caps": "",
                color: "primary",
                size: "lg",
                align: "left",
                flat: "",
                icon: "place"
              },
              on: { click: _vm.pickPlace }
            },
            [_vm._v("\n      Место\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-766e19c4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766e19c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media-modal.vue
// module id = null
// module chunks = 